// React
import React, { Component } from "react";

// Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// Actions
import { generateSsoUrl } from "../module/thinkific/signin";

// Component
import { default as Loadable } from "../../components/_Shared/commonLoadable";

import "./SpocketDeals.css";

class Academy extends Component {
  componentDidMount() {
    this.redirectToSpocketAcademy();
  }

  redirectToSpocketAcademy() {
    let params = new URLSearchParams(window.location.search);
    let academy_url = params.get("academy_url");

    this.props.generateSsoUrl("_self", Boolean(academy_url) ? academy_url : "");
  }

  render() {
    return <Loadable active={true} text="Redirecting to Spocket Academy..." />;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ generateSsoUrl }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps
)(Academy);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/Academy.js